// src/components/private/common_components/FloatingActionButton.js
// This is the FloatingActionButton component

import React, { useState } from 'react';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

const FloatingActionButton = ({ actions }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    // Tooltip wrapper
    const renderTooltip = (props, message) => (
        <Tooltip id="button-tooltip" {...props}>
            {message}
        </Tooltip>
    );

    return (
        <div style={{ position: 'fixed', bottom: 25, right: 25, zIndex: 1050 }}>
            <OverlayTrigger
                placement="left"
                overlay={(props) => renderTooltip(props, isOpen ? "Close" : "Open")}
            >
                <Button
                    onClick={toggle}
                    style={{
                        borderRadius: '50%',
                        padding: '15px',
                        fontSize: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        zIndex: isOpen ? 1051 : 1050  // Ensure the main button is always above or at the same level
                    }}
                    variant="primary"
                    className={isOpen ? 'bi bi-x-lg' : 'bi bi-plus-lg'}
                ></Button>
            </OverlayTrigger>
            {isOpen && (
                <div style={{ position: 'absolute', right: 0, bottom: 60 }}>
                    {actions.map((action, index) => (
                        <OverlayTrigger
                            key={index}
                            placement="left"
                            overlay={(props) => renderTooltip(props, action.tooltip)}
                        >
                            <Button
                                key={index}
                                onClick={action.handler}
                                variant="secondary"
                                style={{
                                    backgroundColor: action.color,
                                    borderColor: action.color,
                                    margin: '5px 0', // consistent spacing
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '50px',
                                    height: '50px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',  // Add shadow for better visibility
                                    transform: isOpen ? `translateY(-${(index + 1) * 60}px)` : 'translateY(0px)',
                                    transition: `transform 0.3s ease-out ${index * 0.3}s, opacity 0.3s ease-out ${index * 0.3}s`,
                                    opacity: isOpen ? 1 : 0,
                                    position: 'absolute',
                                    right: '5px',
                                }}
                                className={action.icon}
                            ></Button>
                        </OverlayTrigger>
                    ))}
                </div>
            )}
        </div>
    );
};

export default FloatingActionButton;
